// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3gLnl","rootSmall":"AddTileButton_rootSmall__10grF"};